import classes from './list.module.scss'
import { IItem } from "../../../model/types";
import { MyCheckbox } from "../../myCheckbox";

interface IProps<TId extends string | number> {
    selectedIdItems: TId[];
    items: IItem<TId>[];
    onSelected: (item: IItem<TId>) => (selected: boolean) => void
    emptyText?: string;
}

export const List = <TId extends string | number,>({items, selectedIdItems, onSelected, emptyText}: IProps<TId>) => {

    return (
        items.length
            ?
        <ul className={classes.list}>
            {items.map(item =>
                <li key={item.id}>
                    <MyCheckbox
                        onSelected={onSelected(item)}
                        checked={selectedIdItems.includes(item.id)}
                    >
                        <section className={classes.itemLabel}>
                            <span>{item.name}</span>
                            {item.secondaryText && <span className={classes.secondaryText}>{item.secondaryText}</span>}
                            {item.tertiaryText && <span className={classes.secondaryText}>{item.tertiaryText}</span>}
                        </section>
                    </MyCheckbox>
                </li>
            )}
        </ul>
            :
        <section className={classes.empty}>
            {emptyText || 'Ничего не найдено'}
        </section>
    )
}
